import routes from '../routes/index.routes';
import { Destinations } from '../../pages/destinations/index/destinations.page';
import { DestinationEditor } from '../../pages/destinations/destination-editor/destination-editor.page';

export const DestinationsRouter = [
	{
		path: routes.destinations.index(),
		element: <Destinations />,
	},
	{
		path: routes.destinations.create(),
		element: <DestinationEditor />,
	},
	{
		path: routes.destinations.edit(':destinationId'),
		element: <DestinationEditor />,
	},
];
